import { render, staticRenderFns } from "./cargoWarehousingExceptionRecords.vue?vue&type=template&id=467aa060&scoped=true"
import script from "./cargoWarehousingExceptionRecords.vue?vue&type=script&lang=js"
export * from "./cargoWarehousingExceptionRecords.vue?vue&type=script&lang=js"
import style0 from "./cargoWarehousingExceptionRecords.vue?vue&type=style&index=0&id=467aa060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467aa060",
  null
  
)

export default component.exports